import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const companyIntegrityGuard: CanActivateFn = (route) => {
  const id = Number(route.paramMap.get('companyId'));
  if (isNaN(id)) {
    inject(Router).navigate(['/companies/list']);
    return false;
  }
  return true;
};
